import { PartImage } from '../types/part/partTypes'

export const buildPartImageUrls = (
    cloudPath: string,
): Pick<PartImage, 'publicUrl' | 'publicUrl_200x150' | 'publicUrl_420x250'> => {
    const fileWithExt = cloudPath.includes('.jpg') || cloudPath.includes('.png')
    const publicUrl = `https://ycs.partsauto.market/partsauto-images/thmbs/${cloudPath}${fileWithExt ? '' : '.jpg'}`
    const rs = (url: string, w: number, h: number) =>
        `https://cdn.partsauto.market/CQYbV8Vwna/rs:fill:${w}:${h}/plain/${url}@jpg`

    return {
        publicUrl,
        publicUrl_200x150: rs(publicUrl, 200, 150),
        publicUrl_420x250: rs(publicUrl, 420, 250),
    }
}
